import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const CustomButton = styled(Button)(
  ({
    theme,
    backgroundColor,
  }: {
    theme: ICustomTheme;
    backgroundColor: string;
  }) => ({
    borderRadius: 0,
    color: theme.colors.white,
    backgroundColor: backgroundColor || theme.colors.paletteFromBO.main,
  }),
);

export const ResetButton = styled(Button)<Theme>(({ theme }) => ({
  background: theme.colors.white,
  color: theme.colors.paletteFromBO.main,
}));
